export const mapRoleTypeToLabel: { [key: string]: string } = {
  Witness: "świadek",
  Participant: "uczestnik",
  Other: "inny",
};
